<template>
  <!-- 配置模板 -->
  <a-breadcrumb>
    <a-breadcrumb-item>配套设置</a-breadcrumb-item>
    <a-breadcrumb-item>版权方管理</a-breadcrumb-item>
  </a-breadcrumb>
  <div class="content">
    <div class="tool-view">
      <!-- 版权方 -->
      <span class="tool-title">版权方：</span>
      <a-input v-model:value="nameModel" style="width: 180px;" placeholder="请输入" />
      <!-- 操作 -->
      <a-button type="primary" style="margin-left: 16px;" @click="touchSearch">查询</a-button>
      <a-button style="margin-left: 16px;" @click="touchReset">重置</a-button>
      <div style="flex: 1;"></div>
      <!-- 其他操作 -->
      <a-button type="primary" @click="add"><plus-outlined />添加分销商</a-button>
    </div>
    <div class="table-box">
      <a-table
        :data-source="dataSource"
        :columns="columns"
        :pagination="pagination"
        :row-key="record => record.id"
        :loading="isLoading"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, record }">
          <!-- IAP分成比例 -->
          <template v-if="column.key === 'iap_rate'">
            {{ record.iap_rate ? `${record.iap_rate}%` : '-' }}
          </template>
          <!-- 操作 -->
          <template v-if="column.key === 'operation'">
            <a class="operation-item" @click="touchEdit(record)">编辑</a>
            <a class="operation-item" @click="touchClient(record)">客户端设置</a>
          </template>
        </template>
      </a-table>
    </div>
    <!-- 新增、编辑弹窗 -->
    <Add ref="RefAdd" @success="getList" />
    <!-- 客户端设置 -->
    <Client ref="RefClient" @success="getList" />
  </div>
</template>

<script setup>
import { ref, reactive, nextTick, onBeforeMount } from 'vue'
import { message, Modal } from 'ant-design-vue'
import Add from './components-copyright-holder/Add.vue'
import Client from './components-copyright-holder/Client.vue'
import { supplierList } from '@/api/request'

// 新增
let RefAdd = ref(null)
// 客户端
let RefClient = ref(null)
// 数据源
let dataSource = ref(null)
// 剧名
let nameModel = ref(undefined)
let name = ref(undefined)
// 加载
let isLoading = ref(false)
// 表头
let columns = reactive([
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '版权方名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '客户端',
    dataIndex: 'client_count',
    key: 'client_count',
  },
  {
    title: 'IAP分成比例',
    dataIndex: 'iap_rate',
    key: 'iap_rate',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])
// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  getList()
})

// 表格change
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 查询
function touchSearch () {
  // 调整参数
  name.value = nameModel.value
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function touchReset () {
  nameModel.value = undefined
  name.value = undefined
  // 初始化获取
  getList()
}

// 请求分页数据
function getList () {
  isLoading.value = true
  const params = {
    name: name.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  supplierList(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 新增弹窗
function add () {
  RefAdd.value.showDrawer({})
}

// 编辑
function touchEdit (record) {
  RefAdd.value.showDrawer(record)
}

// 客户端设置
function touchClient (record) {
  RefClient.value.showDrawer(record)
}
</script>

<style lang="less" scoped>
.content {
  padding: 24px 0;
  .tool-view {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .operation-item {
    margin-right: 8px;
  }
}

</style>